import { slCallings } from './callings';
import { slChores } from './chores';
import { slCovenants } from './covenants';

export const slTasks = [slChores, slCovenants, slCallings];
